import axios from "axios";
import React from "react";
import { withRouter } from "react-router-dom";
import { AxiosURL } from "../../utils/index.js";
import { isFreelanceUser } from "../../utils/freelance-access.js";

class LoginAsCallback extends React.Component {
  componentDidMount() {
    const originalSession = {
      my_code: localStorage.my_code || "",
      refresh: localStorage.refresh || "",
      userId: localStorage.userId || "",
      profile_pic: localStorage.profile_pic || "",
      first_name: localStorage.first_name || "",
      full_name: localStorage.full_name || "",
      email: localStorage.email || "",
      is_freelance: localStorage.is_freelance || "",
      is_team_leader: localStorage.is_team_leader || "",
      is_staff: localStorage.is_staff || "",
      permissions: localStorage.permissions || "",
    };
    if (originalSession.my_code) {
      localStorage.login_as_original = JSON.stringify(originalSession);
    }

    axios
      .get(`${AxiosURL}users/auth/login-as/session`, {
        withCredentials: true,
        params: { t: Date.now() },
      })
      .then(({ data }) => {
        const user = data.user || {};
        localStorage.my_code = data.access;
        localStorage.refresh = data.refresh;
        localStorage.userId = user.id;
        localStorage.profile_pic = user.profile_pic || "";
        localStorage.first_name = user.first_name || "";
        localStorage.full_name = user.full_name || "";
        localStorage.email = user.email || "";
        localStorage.is_freelance = String(
          user.is_freelance || user.person?.is_freelance || false
        );
        localStorage.is_team_leader = String(user.is_team_leader || false);
        localStorage.is_staff = String(
          user.is_staff || user.person?.is_staff || false
        );
        localStorage.permissions = JSON.stringify(data.permissions || {});
        localStorage.is_impersonation = "true";
        localStorage.impersonated_user_id = String(
          data.impersonation?.impersonated_user_id || user.id
        );
        localStorage.original_user_id = String(
          data.impersonation?.original_user_id || ""
        );
        this.props.history.replace(
          isFreelanceUser() ? "/Expedientes" : "/dashboard"
        );
      })
      .catch(() => this.props.history.replace("/user/login"));
  }

  render() {
    return <div className="text-center p-5">Iniciando sesión...</div>;
  }
}

export default withRouter(LoginAsCallback);
